<app-banner [title]="'Suivi Santé'" [links]="links"></app-banner>

<div class="container">
  <!-- Header Section -->
  <div class="flex items-center justify-between mb-4">
    <div>
      <p class="mt-1 text-[14px] text-gray-400">Gérez vos événements de santé passés et à venir</p>
    </div>
  </div>

  <!-- État de chargement global -->
  <div *ngIf="isLoadingCalendar && isLoadingList" class="flex items-center justify-center py-8">
    <div class="text-center">
      <div class="animate-spin rounded-full h-8 w-8 border-b-2 border-primary mx-auto mb-2"></div>
      <p class="text-sm text-gray-500">Chargement des données...</p>
    </div>
  </div>

  <!-- Message d'erreur -->
  <div *ngIf="error && !isLoadingList" class="bg-red-50 border border-red-200 rounded-md p-4 mb-4">
    <div class="flex">
      <div class="flex-shrink-0">
        <i class="ri-error-warning-line text-red-400"></i>
      </div>
      <div class="ml-3">
        <h3 class="text-sm font-medium text-red-800">Erreur de chargement</h3>
        <div class="mt-2 text-sm text-red-700">
          <p>{{ error }}</p>
        </div>
        <div class="mt-4">
          <button 
            (click)="loadHealthEvents()"
            class="bg-red-100 px-3 py-2 rounded-md text-sm font-medium text-red-800 hover:bg-red-200">
            Réessayer
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Layout principal avec calendrier et liste -->
  <div *ngIf="!isLoadingCalendar || !isLoadingList" class="flex gap-6 flex-col-reverse lg:flex-row">
    <!-- Calendrier à gauche -->
    <div class="w-full lg:w-96">
      <!-- Indicateur de chargement pour le calendrier -->
      <div *ngIf="isLoadingCalendar" class="flex items-center justify-center py-8 bg-white rounded-lg shadow">
        <div class="text-center">
          <div class="animate-spin rounded-full h-6 w-6 border-b-2 border-primary mx-auto mb-2"></div>
          <p class="text-xs text-gray-500">Chargement du calendrier...</p>
        </div>
      </div>
      
      <!-- Calendrier -->
      <div *ngIf="!isLoadingCalendar">
        <!-- Message d'erreur pour le calendrier -->
        <div *ngIf="error && calendarEvents.length === 0" class="bg-red-50 border border-red-200 rounded-lg p-4 mb-4">
          <div class="flex items-center">
            <i class="ri-error-warning-line text-red-400 mr-2"></i>
            <div>
              <p class="text-sm text-red-800">Erreur de chargement du calendrier</p>
              <button (click)="loadHealthEvents()" 
                      class="mt-1 text-xs text-red-600 hover:text-red-800 underline">
                Réessayer
              </button>
            </div>
          </div>
        </div>
        
        <!-- Calendrier -->
        <app-calendar 
          [events]="calendarEvents"
          [selectedDate]="selectedDate"
          (dateSelected)="onDateSelected($event)"
          (eventClicked)="onEventClicked($event)">
        </app-calendar>
      </div>
      
      <!-- Événements du jour sélectionné -->
      <!-- <div *ngIf="selectedDateEvents.length > 0" class="mt-4 bg-white shadow rounded-lg p-4">
        <div class="flex items-center justify-between mb-2">
          <h4 class="text-[12px] font-medium text-gray-600">{{ getSelectedDateFormatted() }}</h4>
        </div>
        <div class="space-y-2">
          <div *ngFor="let event of selectedDateEvents" 
               class="flex items-center gap-2 p-2 bg-gray-50 rounded text-[10px]">
            <div class="w-2 h-2 rounded-full" 
                 [class]="event.status === 'completed' ? 'bg-green-500' : 'bg-blue-500'"></div>
            <span class="text-gray-600">{{ formatTime(event.date) }}</span>
            <span class="font-medium text-gray-900 truncate">{{ event.title }}</span>
          </div>
        </div>
      </div> -->
    </div>

    <!-- Liste des événements à droite (overflow-visible pour le dropdown) -->
    <div class="flex-1 shadow rounded-md px-5 py-3 bg-white h-fit overflow-visible min-w-0">
      <!-- Indicateur de chargement pour la liste -->
      <div *ngIf="isLoadingList" class="flex items-center justify-center py-8">
        <div class="text-center">
          <div class="animate-spin rounded-full h-6 w-6 border-b-2 border-primary mx-auto mb-2"></div>
          <p class="text-xs text-gray-500">Chargement des événements...</p>
        </div>
      </div>
      
      <!-- Contenu de la liste -->
      <div *ngIf="!isLoadingList" class="overflow-visible">
      <!-- Titre de section et statistiques -->
      <div class="flex items-center justify-between mb-4">
        <div>
          <h3 class="!text-[16px] font-medium text-gray-900">
            Suivi santé
            <!-- {{ getSectionTitle() }} -->
          </h3>
          <p class="text-xs text-gray-500">
            {{ getSectionStats() }}
          </p>
        </div>
      </div>
      
      <!-- Sous-onglets de filtrage temporel -->
      <div class="flex gap-1 mb-4">
        <button 
          *ngFor="let tab of filterTabs" 
          (click)="setActiveTab(tab.key)"
          class="px-3 py-1 text-[10px] rounded"
          [class.bg-primary]="activeTab === tab.key"
          [class.text-white]="activeTab === tab.key"
          [class.text-gray-600]="activeTab !== tab.key"
          [class.bg-gray-100]="activeTab !== tab.key">
          {{ tab.label }}
        </button>
      </div>
      
      <!-- Liste des événements (overflow-visible pour que le dropdown ne soit pas coupé) -->
      <div class="space-y-2 overflow-visible">
        <div *ngFor="let event of filteredEvents" 
             (click)="navigateToEventDetails(event, 'appointment')"
             class="bg-white flex cursor-pointer items-center justify-between p-3 border border-gray-200 rounded-lg hover:bg-gray-50 overflow-visible">
          <div class="flex items-center gap-3">
            <div class="text-[10px] text-gray-500">
              <div>{{ formatDateShort(event.date) }}</div>
              <div *ngIf="(event.appointment?.startTime && event.appointment?.endTime) || (getStartTime(event) && getEndTime(event))">
                {{ formatTimeString(getStartTime(event)) }} - {{ formatTimeString(getEndTime(event)) }}
              </div>
              <div *ngIf="!getStartTime(event) || !getEndTime(event)">
                {{ formatTime(event.date) }}
              </div>
            </div>
            <!-- Photo du docteur ou icône par défaut -->
            <div class="w-8 h-8 rounded-full flex items-center justify-center overflow-hidden">
              <img *ngIf="event.doctorPhoto && !hasImageError(event.doctorPhoto)" 
                   [src]="event.doctorPhoto" 
                   [alt]="event.doctor || 'Docteur'"
                   class="w-full h-full object-cover"
                   (error)="onImageError($event)">
              <div *ngIf="!event.doctorPhoto || hasImageError(event.doctorPhoto)" 
                   class="w-full h-full bg-gray-200 rounded-full flex items-center justify-center">
                <lucide-icon [img]="UserIcon" color="gray" [size]="21"></lucide-icon>
              </div>
            </div>
            <div>
              <div class="text-sm font-medium text-gray-900">{{ event.title }}</div>
              <div class="text-[10px] text-gray-500">
                <span *ngIf="event.user?.firstName || event.user?.lastName" class="font-medium">
                  {{ event.user?.firstName }} {{ event.user?.lastName }}
                  <span *ngIf="event.doctor || event.structureName" class="text-gray-400"> - </span>
                </span>
                {{ event.doctor || 'Non spécifié' }}
                <span *ngIf="event.structureName" class="text-gray-400"> - {{ event.structureName }}</span>
                <span *ngIf="event.amount && event.currency" class="ml-2 font-medium text-green-600">
                  {{ formatAmount(event.amount, event.currency) }}
                </span>
              </div>
            </div>
          </div>
          <div class="flex items-center gap-2 relative overflow-visible">
            <span class="px-2 py-1 text-[10px] rounded-full"
                  [class]="getStatusBadgeClass(event.status)">
              {{ getStatusText(event.status) }}
            </span>
            <!-- Dropdown d'options - affiché uniquement si on peut annuler -->
            <div *ngIf="canCancelAppointment(event)" class="relative dropdown-container overflow-visible">
              <button 
                (click)="toggleDropdown(event.id, $event)"
                class="p-1.5 text-gray-400 hover:text-gray-600 hover:bg-gray-100 rounded transition-colors flex items-center justify-center">
                <lucide-icon [img]="MoreVerticalIcon" color="gray" [size]="18"></lucide-icon>
              </button>
              
              <!-- Menu dropdown (z-index élevé pour passer au-dessus des autres blocs) -->
              <div *ngIf="isDropdownOpen(event.id)" 
                   class="absolute right-0 mt-1 w-40 bg-white rounded-md shadow-lg border border-gray-200 py-1 min-w-[8rem]"
                   style="z-index: 50;">
                <button 
                        *ngIf="canPayAppointment(event)"
                        (click)="$event.stopPropagation(); payAppointment(event)"
                        class="w-full text-left px-3 py-2 text-[11px] text-primary-600 hover:bg-primary-50 transition-colors flex items-center gap-2">
                  <span>Payer</span>
                </button>
                <button 
                        (click)="$event.stopPropagation(); cancelAppointment(event)"
                        class="w-full text-left px-3 py-2 text-[11px] text-red-600 hover:bg-red-50 transition-colors flex items-center gap-2">
                  <span>Annuler</span>
                </button>
              </div>
            </div>
          </div>
        </div>
        
        <!-- État vide -->
        <div *ngIf="filteredEvents.length === 0 && !isLoadingList" class="text-center py-8">
          <i [class]="getSectionIcon()" class="text-2xl text-gray-400 mb-2"></i>
          <p class="text-[12px] text-gray-500">
            {{ error ? 'Erreur de chargement des données' : getEmptyStateMessage() }}
          </p>
          <button *ngIf="error" 
                  (click)="loadHealthEvents()"
                  class="mt-2 px-3 py-1 text-xs bg-primary text-white rounded hover:bg-primary-dark">
            Réessayer
          </button>
        </div>
      </div>
      
      <!-- Pagination -->
      <div *ngIf="filteredEvents.length > 0 && !isLoadingList" class="mt-4">
        <app-pagination
          [currentPage]="getCurrentPaginationInfo().currentPage"
          [totalPages]="getCurrentPaginationInfo().totalPages"
          [totalItems]="getCurrentPaginationInfo().totalItems"
          [itemsPerPage]="itemsPerPage"
          [showInfo]="true"
          (pageChange)="goToPage($event)">
        </app-pagination>
      </div>
      </div> <!-- Fin du contenu de la liste -->
    </div>
  </div>
</div>
